import * as ng from 'angular';
import { OverviewDataObject } from '../../../../../../organisms';

export class MoleculeOverviewPricelistRowPanelDomainsController implements ng.IController {
    public static $inject: string[] = [];

    public overviewData: OverviewDataObject;
}

export class MoleculeOverviewPricelistRowPanelDomainsComponent implements ng.IComponentOptions {
    public require = {
        organismPricelistOverview: '^organismPricelistOverview'
    };
    public bindings = {
        overviewData: '<'
    };
    public controller =  MoleculeOverviewPricelistRowPanelDomainsController;
    public controllerAs = 'OverviewPricelistCtrl';
    public template = require('./pricelist-domains-row.html');
}
